import { render, staticRenderFns } from "./IconLoading.vue?vue&type=template&id=999366f4&"
import script from "./IconLoading.vue?vue&type=script&lang=js&"
export * from "./IconLoading.vue?vue&type=script&lang=js&"
import style0 from "./IconLoading.vue?vue&type=style&index=0&id=999366f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports